import React, { useContext } from "react";
import { Row, Col, FormGroup, FormControl, FormLabel, Form } from "react-bootstrap";
import { useWizard } from "./WizardContext";
import Select from "react-select";
import { useGuestContext } from "../../../../contexts/GuestContext";
import LanguageToggle from "../LanguageToggle";
import SweetAlert from "react-bootstrap-sweetalert";
import cuteMonk1 from "../../../../assets/img/baolinPrivate/cute_monk1.png";
import cuteMonk2 from "../../../../assets/img/baolinPrivate/cute_monk2.png";
import cuteVege1 from "../../../../assets/img/baolinPrivate/cute_vege1.png";
import cuteVege2 from "../../../../assets/img/baolinPrivate/cute_vege2.png";
import lunarLamp1 from "../../../../assets/img/baolinPrivate/lunarlamp.png";
import lunarLampRight from "../../../../assets/img/baolinPrivate/lunarLampRight.png";
import lunarLampLeft from "../../../../assets/img/baolinPrivate/lunarLampLeft.png";

const Step1 = React.forwardRef((props, ref) => {
  const {
    firstname, setFirstname,
    lastname, setLastname,
    chinesename, setChinesename,
    email, setEmail,
    phone, setPhone,
    event1, setEvent1,
    event2, setEvent2,
    headcountEvent1, setHeadcountEvent1,
    headcountEvent2, setHeadcountEvent2,
    timeslot, setTimeslot

  } = useWizard();

  const { language } = useGuestContext();

  //define error messages
  const [firstnameError, setFirstnameError] = React.useState(null);
  const [lastnameError, setLastnameError] = React.useState(null);
  const [emailError, setEmailError] = React.useState(null);
  const [phoneError, setPhoneError] = React.useState(null);
  const [chinesenameError, setChinesenameError] = React.useState(null);


  //state for warning alert
  const [alertState, setAlertState] = React.useState(null);

  const handleCheckboxChange = (event, setSession) => {
    setSession(event.target.checked);
  };

  const handleNameChange = (value, setName, setError, isChineseName = false) => {
    // Regular expression for non-Chinese names: allows letters, spaces, hyphens, and apostrophes
    const nameRegex = /^[A-Za-z\s'-]+$/;
    // Regular expression for Chinese names: allows Chinese characters (including simplified and traditional), spaces, and common name characters
    const chineseNameRegex = /^[\u4e00-\u9fa5\s·]+$/;

    let isValid = isChineseName ? chineseNameRegex.test(value) : nameRegex.test(value);

    if (!isValid && value !== "") {
      setError(
        <small className="text-danger">
          {language === "English"
            ? isChineseName
              ? "Invalid characters. Only Chinese characters are allowed."
              : "Invalid characters. Only letters, spaces, hyphens, and apostrophes are allowed."
            : isChineseName
              ? "包含无效字符。只允许中文字符。"
              : "包含无效字符。只允许字母、空格、连字符和撇号。"
          }
        </small>
      );
    } else {
      setError(null);
    }
    setName(value);
  };
  const isValidated = () => {
    console.log("hey");
    // var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    // re.test(email) === false
    //   ? setEmailError(
    //     <small className="text-danger">
    //       {language === "English" ? "Invalid email format. A correct format looks like john@doe.com." : "電子郵件格式不正確  正確格式類似於john@doe.com."}
    //     </small>
    //   )
    //   : setEmailError(null);
    //check firstname
    (firstname === null || firstname.trim() === "")
      ? setFirstnameError(
        <small className="text-danger">{language === "English" ? "First name is required." : "未填寫英文名"}</small>
      )
      : setFirstnameError(null);

    //check lastname
    (lastname === null || lastname.trim() === "")
      ? setLastnameError(
        <small className="text-danger">{language === "English" ? "Last name is required." : "未填寫英文姓"}</small>
      )
      : setLastnameError(null);

    (phone === null || phone.trim() === "")
      ? setPhoneError(
        <small className="text-danger">{language === "English" ? "Please enter a contact phone number." : "請填息聯繫電話以方便聯絡."}</small>
      )
      : setPhoneError(null);

    // var gd = gender !== null;
    // var em = re.test(email) === true;
    var fn = !(firstname === null || firstname.trim() === "");
    var ln = !(lastname === null || lastname.trim() === "");
    var ph = !(phone === null || phone.trim() === "");
    var valid = fn && ln && ph;
    if (!valid) {
      alert(`Validation failed. Please check: Firstname=${fn ? 'OK' : 'Missing'}, Lastname=${ln ? 'OK' : 'Missing'}, Phone=${ph ? 'OK' : 'Missing'}`);
    }
    return valid;
  };

  React.useImperativeHandle(ref, () => ({
    isValidated: () => {
      return isValidated();
    },
  }));

  return (
    <>
      {alertState}
      <div className="wizard-step" ref={ref}>
        <p className="text-center mb-2 font-weight-bold">
          <img src={lunarLampLeft} alt="Company Logo" width="40" className="mr-3" />
          {language === "English" ? "Personal Information" : "請提供以下個人信息"}
          <img src={lunarLampRight} alt="Company Logo" width="40" className="ml-3" />
        </p>
        <hr />
        <LanguageToggle />
        <hr />
        <Row>
          <Col md={{ span: 5, offset: 1 }}>
            <FormGroup>
              <FormLabel>
                {language === "English" ? "First Name (Required)" : "英 文 名（必填）"}<span className="text-danger">*</span>
              </FormLabel>
              <FormControl
                type="text"
                name="firstname"
                placeholder="ex: Mike"
                maxLength="30"
                value={firstname}
                onChange={(event) => handleNameChange(event.target.value, setFirstname, setFirstnameError)}
              />
              {firstnameError}
            </FormGroup>
          </Col>
          <Col md={5}>
            <FormGroup>
              <FormLabel>
                {language === "English" ? "Last Name (Required)" : "英 文 姓（必填）"}<span className="text-danger">*</span>
              </FormLabel>
              <FormControl
                type="text"
                name="lastname"
                maxLength="30"
                placeholder="ex: Andrew"
                value={lastname}
                onChange={(event) => handleNameChange(event.target.value, setLastname, setLastnameError)}
              />
              {lastnameError}
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={{ span: 5, offset: 1 }}>
            <FormGroup>
              <FormLabel>
                {language === "English" ? "Chinese Name" : "中 文 姓 名"}
              </FormLabel>
              <FormControl
                type="text"
                name="chinesename"
                maxLength="30"
                placeholder={language === "English" ? "ex: Wukong" : "ex：悟空"}
                value={chinesename}
                onChange={(event) => handleNameChange(event.target.value, setChinesename, setChinesenameError, true)}
              />
              {chinesenameError}
            </FormGroup>
          </Col>
          <Col md={{ span: 5 }}>
            <FormGroup>
              <FormLabel>
                {language === "English" ? "Phone Number (Required for contact)" : "電 話 號 碼（必填，聯絡用）"} <span className="text-danger">*</span>
              </FormLabel>
              <FormControl
                type="number"
                name="phone"
                maxLength="30"
                placeholder="ex: 0433233343"
                value={phone}
                onChange={(event) => setPhone(event.target.value)}
              />
              {phoneError}
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={{ span: 5, offset: 1 }}>
            <FormGroup>
              <FormLabel>
                {language === "English" ? "Email (optional for contact)" : "電 子 郵 件（聯絡用）"}
              </FormLabel>
              <FormControl
                type="email"
                name="email"
                maxLength="50"
                placeholder="ex: wukong@baolin.com"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
              />
              {emailError}
            </FormGroup>
          </Col>
        </Row>
      </div>
    </>
  );
});

export default Step1;
